import { Link } from 'react-router-dom'
import Modal from '../../../core/components/UI/Modal'
import { MdDelete, MdEdit } from 'react-icons/md'
import { IoMdEye, IoMdEyeOff } from 'react-icons/io'
import { GiCrossedChains } from 'react-icons/gi'
import useMineralsActions from '../../hooks/useMineralsActions'
import { FaSpinner } from 'react-icons/fa'
import { toastSuccess } from '../../../helper'
import ButtonDeleteMineral from './ButtonDeleteMineral'

export default function ModalMineralsOptions({ isOpen, onClose, mineral }) {
  const { toggleMineralStatus, inProgress } = useMineralsActions()
  async function handleOnToggleMineralStatus() {
    const message = await toggleMineralStatus(mineral.id)
    if (message) {
      toastSuccess(message)
    }
  }

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      className={`min-w-[512px] border-2 border-muted-500 bg-white`}
    >
      <ul className="flex flex-col gap-1 p-2">
        <li>
          <Link
            to={`/minerals/${mineral.id}/edit`}
            className="flex items-center gap-4 border-2 border-muted-300 px-4 py-2 hover:bg-muted-300"
          >
            <MdEdit size={18} />
            <div>تعديل المعدن</div>
          </Link>
        </li>
        <li>
          <button
            onClick={handleOnToggleMineralStatus}
            disabled={inProgress}
            className="flex w-full items-center gap-4 border-2 border-muted-300 px-4 py-2 hover:bg-muted-300 disabled:cursor-not-allowed disabled:border-muted-500 disabled:bg-muted-300 disabled:text-primary-600"
          >
            {inProgress ? (
              <div className="flex items-center">
                <FaSpinner
                  size={16}
                  className="ml-2 animate-spin"
                />
                <div>جاري تغيير حالة المعدن...</div>
              </div>
            ) : (
              <>
                {mineral.status === 'PUBLISHED' ? (
                  <>
                    <IoMdEyeOff />
                    <div>إلغاء النشر</div>
                  </>
                ) : (
                  <>
                    <IoMdEye />
                    <div>نشر</div>
                  </>
                )}
              </>
            )}
          </button>
        </li>
        <li>
          <Link
            to={
              mineral.has_value_chaine
                ? `/minerals/${mineral.id}/value-chain/edit`
                : `/minerals/${mineral.id}/value-chain/create`
            }
            className="flex items-center gap-4 border-2 border-muted-300 px-4 py-2 hover:bg-muted-300"
          >
            <GiCrossedChains />
            {mineral.has_value_chaine ? (
              <div>تعديل سلسلة القيمة</div>
            ) : (
              <div>إضافة سلسلة القيمة</div>
            )}
          </Link>
        </li>
        <li>
          <ButtonDeleteMineral
            mineralId={mineral.id}
            onClose={onClose}
          />
        </li>
      </ul>
    </Modal>
  )
}
